import { useEffect } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

import Header from "./Header/Header";
import MainDrawer from "./Drawer/MainDrawer";
import { Outlet } from "react-router-dom";
import { useGetSideBarMenu } from "../../../contexts/DrawerContext";

export default function DashboardLayout() {
  const { menuMasterLoading, handlerDrawerOpen } = useGetSideBarMenu();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  useEffect(() => {
    handlerDrawerOpen(!downXL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  if (menuMasterLoading) return <></>;

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <Header />
      <MainDrawer />

      <Box
        component="main"
        sx={{
          width: "calc(100% - 260px)",
          flexGrow: 1,
          mt: "60px",
        }}
      >
        <Box
          sx={{
            pl: 0,
            position: "relative",
            minHeight: "calc(100vh - 60px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
